export default __webpack_public_path__ + "static/media/expl_04_EN.b4421996.png";